webpackJsonp([36,47],{

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var list = [{
  text: 'Spending Analysis by Geography',
  id: 'spending-analysis-by-geography',
  downloadLink: 'https://us-east-1.online.tableau.com/api/3.3/sites/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/pdf',
  embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/DoDSpendingTrendsbyGeorgraphy?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
}, {
  text: 'DoD Contract Trends',
  id: 'dod-contract-trends',
  embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/DoDContractSpendingTrends?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
}, //   {
//     text: 'Military Installations',
//     id: 'military-installations',
//     html: `<div class='tableauPlaceholder' style='width: 1000px; height: 827px;'><object class='tableauViz' width='1000' height='827' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_MilitaryInstallations_12172018&#47;MilitaryInstallations' /><param name='tabs' value='no' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
//     embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_MilitaryInstallations_12172018/MilitaryInstallations?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
//   },
{
  text: 'Prime-Sub Spending Flow',
  id: 'prime-sub-spending-flow',
  embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_AgencySpendingFlow/DoDPrime-SubSpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
}, {
  text: 'DoD Agency Spending Flow',
  id: 'dod-agency-spending-flow',
  embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_AgencySpendingFlow/DoDSub-AgencySpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
}, {
  text: 'Future Needs of the DoD',
  id: 'future-needs-of-the-dod',
  embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/FutureNeedsoftheDoD?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
}, {
  text: 'DoD Contract View',
  id: 'dod-contract-view',
  embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/DoDContractView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
}, {
  text: 'DoD Contractor View',
  id: 'dod-contractor-view',
  embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/DoDContractorView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
}, {
  text: 'GDX Directory vs. Georgia DoD Contract Winners',
  id: 'gdx-directory-vs-georgia-dod-contract-winners',
  embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/GDXDirectoryvs_GeorgiaDoDContractWinners?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
}, {
  text: 'Georgia Contractor Analysis',
  id: 'georgia-contractor-analysis',
  embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_DoDContractAnalytics_1/GeorgiaDoD_Contractor?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
}];
/* harmony default export */ __webpack_exports__["a"] = list;

/***/ }),

/***/ 1265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__analysisList__ = __webpack_require__(1148);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      analysisList: __WEBPACK_IMPORTED_MODULE_0__analysisList__["a" /* default */]
    };
  },
  computed: {
    privileges: function privileges() {
      return this.$store.getters.getUserPrivileges;
    },
    page: function page() {
      return this.$store.getters.getPages['dod-contract-analytics'];
    }
  },
  mounted: function mounted() {
    var payload = {
      meta: {
        h1: "".concat(this.page.header),
        title: "".concat(this.page.header),
        description: "".concat(this.page.sub_text),
        keywords: '',
        requiresAuth: true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit('setHeaderInfo', payload);
  }
};

/***/ }),

/***/ 1418:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".contract-analysis-tile-link{text-decoration:none}.contract-analysis-tile{height:150px;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;text-transform:uppercase;text-align:center;background-position:50%!important;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;background-size:cover;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/DoDContractAnalyticsView.vue"],"names":[],"mappings":"AACA,6BACE,oBAAsB,CACvB,AACD,wBACE,aAAc,AACd,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AAC1B,kBAAmB,AACnB,kCAAuC,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,eAAgB,AAChB,sBAAuB,AACvB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC","file":"DoDContractAnalyticsView.vue","sourcesContent":["\n.contract-analysis-tile-link {\n  text-decoration: none;\n}\n.contract-analysis-tile {\n  height: 150px;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  text-transform: uppercase;\n  text-align: center;\n  background-position: center !important;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n  background-size: cover;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1507:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1418);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("19388465", content, true, {});

/***/ }),

/***/ 1718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "dod-contract-analytics-view",
    staticStyle: {
      "padding-top": "60px",
      "max-width": "1442px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "page-header-body",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md9": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "page-header",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "29px",
      "font-weight": "bolder",
      "text-justify": "auto"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.page.header))])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "18px",
      "font-weight": "400",
      "margin": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "padding-top": "0px"
    }
  }, [_c('p', {
    staticClass: "page-header-subtext page-subtitle",
    staticStyle: {
      "text-justify": "auto",
      "line-height": "22px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.page.sub_text) + "\n          ")])])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "mt-2": ""
    }
  }, [_c('v-card', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.analysisList), function(analysis, index) {
    return (_vm.privileges.economic_impact && _vm.privileges.economic_impact[analysis.id]) ? _c('v-flex', {
      key: index,
      attrs: {
        "xs12": "",
        "md3": "",
        "xl3": "",
        "pa-2": ""
      }
    }, [_c('router-link', {
      staticClass: "contract-analysis-tile-link",
      attrs: {
        "to": ("dod-contract-analytics/" + (analysis.id)),
        "exact": ""
      }
    }, [_c('div', {
      staticClass: "contract-analysis-tile secondary",
      style: ({
        'backgroundImage': ("url('/static/img/gdx-dod-contract-analytics-tile-" + (index + 1) + ".png')")
      })
    }, [_c('span', {
      staticClass: "white--text"
    }, [_vm._v(_vm._s(analysis.text))])])])], 1) : _vm._e()
  }), 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1507)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1265),
  /* template */
  __webpack_require__(1718),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/36.e719df2acfee4a9b6000.js